import {
  IIngestJob,
  IIngestPhaseEntry,
  IngestTranscoder,
} from "@nendaTypes/NendaTypes";

type IngestPhaseDetails = NonNullable<IIngestPhaseEntry["details"]>;

/**
 * Which transcoder ran a job. `transcoder` is optional on `IIngestJob`: every job dispatched
 * before the field existed went to Encore, so an absent value reads as `encore`.
 */
export function resolveIngestTranscoder(
  job?: Pick<IIngestJob, "transcoder"> | null
): IngestTranscoder {
  return job?.transcoder === "videocore" ? "videocore" : "encore";
}

/**
 * The status, the free-text message and the raw job response a phase's `details` holds for the
 * given transcoder.
 *
 * The two transcoders write separate keys holding separate vocabularies (`queued`/`running`/
 * `done` on one side, Encore's own words on the other), which is why the keys were never merged.
 * The reading side picks one label and this picks the value behind it.
 */
export function selectTranscoderReport(
  transcoder: IngestTranscoder,
  details?: IngestPhaseDetails
): { status?: string; message?: string; jobResponse?: unknown } {
  if (transcoder === "videocore") {
    return {
      status: details?.videocoreStatus,
      message: details?.videocoreMessage,
      jobResponse: details?.videocoreJobResponse,
    };
  }
  return {
    status: details?.encoreStatus,
    message: details?.encoreMessage,
    jobResponse: details?.encoreJobResponse,
  };
}
